import { render, staticRenderFns } from "./walk-into.vue?vue&type=template&id=076ed3b9&scoped=true&"
import script from "./walk-into.vue?vue&type=script&lang=js&"
export * from "./walk-into.vue?vue&type=script&lang=js&"
import style0 from "./walk-into.vue?vue&type=style&index=0&id=076ed3b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076ed3b9",
  null
  
)

export default component.exports